export function extractAccessTokenJwt(session) {
  if (!session) return null;

  // old Auth.currentSession() form
  if (typeof session.getAccessToken === "function") {
    try {
      return session.getAccessToken().getJwtToken();
    } catch {}
  }

  const access = session.tokens?.accessToken;
  if (!access) return null;

  if (typeof access === "string") return access;
  try {
    return access.getJwtToken();
  } catch {}
  if (typeof access.jwt === "string") return access.jwt;
  if (typeof access.jwtToken === "string") return access.jwtToken;

  try {
    return String(access);
  } catch {
    return null;
  }
}
